module.exports = __webpack_public_path__ + "media/couriers/tnt_logo-8d8c9241.png";